/**
 * 微信公众号绑定账号页面
 * 2020-10-23 wuw
 */
import React from 'react';

import ReactDOM from 'react-dom';
import { Button, Icon } from 'antd';

import "../../../style/common/login.css";

import http from '../../../axios/http';
import { getUrlParam } from '../../../util/util.js';

import BindAccount from './BindAccount';
import loginbg from '../../../style/img/loginbg.png';
import logo from '../../../style/img/logo-min1.png';
import server from '../../../axios/server';

const authorizationUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=APPID&redirect_uri=REDIRECT_URI&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";

class WechatLogin extends React.Component {

    state = {
        loadingFlag: false,
        showBanner: false
    }

    componentDidMount() {
        let loginStatus = sessionStorage.getItem("loginStatus");
        //要跳转的目的地址
        let redirectUri = getUrlParam("redirectUri");
        if (loginStatus === "true") {
            if (redirectUri && redirectUri !== "none") {
                this.jumpRedirectUri(redirectUri);
            }
            else {
                http.post({
                    url: "/auth/findUserInfo",
                    success: (res) => {
                        this.setState({
                            username: res.username,
                            showBanner: true
                        });
                    }
                });
            }
        }
        else {
            let code = getUrlParam("code");
            let state = getUrlParam("state");
            if (!code) {
                this.jumpLink(redirectUri);
            } else {
                this.loginByCode(code, state);
            }
        }
    }

    jumpRedirectUri = (redirectUri) => {
        let uri = unescape(redirectUri);
        let redirectUrl = window.location.protocol + "//" + window.location.host + uri;
        window.location.replace(redirectUrl);
    }

    loginByCode = (code, redirectUri) => {
        this.setState({
            loadingFlag: true,
        })
        console.log("loginByCode, code: " + code);
        http.post({
            url: "/login",
            data: { code: code, wxLogin: "true", wxApp: "offiaccount" },
            success: (res) => {
                //登录成功，设置登录状态
                sessionStorage.setItem("loginStatus", "true");
                //有需要跳转的地址
                if (redirectUri && redirectUri !== "none") {
                    this.jumpRedirectUri(redirectUri);
                }
                else {
                    http.post({
                        url: "/auth/findUserInfo",
                        success: (res) => {
                            this.setState({ username: res.username, showBanner: true });
                        }
                    });
                }
                this.setState({
                    loadingFlag: false
                })
            },
            error: (res) => {
                this.setState({
                    loadingFlag: false
                })
                ReactDOM.render(<BindAccount redirectUri={redirectUri} />, document.getElementById('root'));
            }
        });
    }

    jumpLink = (redirectUri) => {
        if (!redirectUri) {
            redirectUri = "none";
        }
        let authUrl = authorizationUrl.replace("APPID", server.wechatAppId)
            .replace("REDIRECT_URI", encodeURI(window.location.href.split("?")[0]))
            .replace("STATE", redirectUri);
        window.location.replace(authUrl);
    }

    initStateHtml = () => {
        let username = this.state.username;
        if (username === null || username === undefined) {
            return "";
        }
        return <div className="wxlogin">
            <div style={{ textAlign: "center", margin: "20px 0", fontSize: "16px", fontWeight: 700 }}>您已绑定账号：{username}
                <div style={{ textAlign: "center", margin: "20px 0" }}>
                    <Button className="bindbtn" type="primary" onClick={this.switchBindPage.bind(this)}><Icon type="swap" />切换账号</Button>
                </div>
            </div>
        </div>;
    }

    switchBindPage = () => {
        ReactDOM.render(<BindAccount />, document.getElementById('root'));
    }

    render() {
        const showBanner = this.state.showBanner;
        return <div className="wxloginPage">
            {showBanner ? (<div className="wxloginBanner">
                <div className="wxloginBannerbox">
                    <img src={loginbg} alt="" />
                    <span className="wxloginMask"></span>
                </div>
                <div className="wxlogin-logo">
                    <img src={logo} alt=""></img>
                </div>
            </div>) : ""}
            {this.state.loadingFlag ? <div className="wxloginPage-mask">
                <div className="wxloginPage-maskbox">
                    <Icon type="loading" className="loading" style={{ fill: '#fff' }}></Icon>
                    <span>自动登录中...</span>
                </div>
            </div> : ''}

            {this.initStateHtml()}
        </div>
    };
}

export default WechatLogin;